/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MovieCameraIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Movie Camera',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M32.4 10.2 24 16.5V9.818A1.818 1.818 0 0 0 22.182 8H5.818A1.818 1.818 0 0 0 4 9.818v16.364A1.818 1.818 0 0 0 5.818 28h16.364A1.818 1.818 0 0 0 24 26.182V19.5l8.4 6.3A1 1 0 0 0 34 25V11a1 1 0 0 0-1.6-.8Z"
    />
  </svg>`;
};
